module.exports = __webpack_public_path__ + "static/media/MinuteMail_Logo-02_1590163208745.dbc6da08.png";